var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 -2 20 20",
    "aria-labelledby": titleId,
    unstroked: "true",
    role: "presentation",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "box",
    lang: "en"
  }, "box icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "box",
    lang: "en"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.25909 5.5175C4.50638 5.5175 5.5175 4.50638 5.5175 3.25909C5.5175 2.01181 4.50638 1.00068 3.25909 1.00068C2.01181 1.00068 1.00068 2.01181 1.00068 3.25909C1.00068 4.50638 2.01181 5.5175 3.25909 5.5175Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25909 1.60292C2.34442 1.60292 1.60292 2.34442 1.60292 3.25909C1.60292 4.17377 2.34442 4.91526 3.25909 4.91526C4.17377 4.91526 4.91526 4.17377 4.91526 3.25909C4.91526 2.34441 4.17377 1.60292 3.25909 1.60292ZM0.398438 3.25909C0.398438 1.6792 1.6792 0.398438 3.25909 0.398438C4.83899 0.398438 6.11975 1.6792 6.11975 3.25909C6.11975 4.83899 4.83899 6.11975 3.25909 6.11975C1.6792 6.11975 0.398438 4.83899 0.398438 3.25909Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8098 14.5508C18.0571 14.5508 19.0682 13.5397 19.0682 12.2924C19.0682 11.0451 18.0571 10.034 16.8098 10.034C15.5625 10.034 14.5514 11.0451 14.5514 12.2924C14.5514 13.5397 15.5625 14.5508 16.8098 14.5508Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8098 10.6363C15.8951 10.6363 15.1536 11.3777 15.1536 12.2924C15.1536 13.2071 15.8951 13.9486 16.8098 13.9486C17.7245 13.9486 18.466 13.2071 18.466 12.2924C18.466 11.3777 17.7245 10.6363 16.8098 10.6363ZM13.9491 12.2924C13.9491 10.7125 15.2299 9.43177 16.8098 9.43177C18.3897 9.43177 19.6704 10.7125 19.6704 12.2924C19.6704 13.8723 18.3897 15.1531 16.8098 15.1531C15.2299 15.1531 13.9491 13.8723 13.9491 12.2924Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91526 3.25909C4.91526 2.92648 5.18543 2.65712 5.51804 2.65712H19.0685C19.4011 2.65712 19.6707 2.92675 19.6707 3.25936C19.6707 3.59197 19.4011 3.8616 19.0685 3.8616H5.51804C5.18543 3.8616 4.91526 3.5917 4.91526 3.25909Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.398438 12.2927C0.398437 11.9601 0.668071 11.6904 1.00068 11.6904H14.5511C14.8838 11.6904 15.1536 11.9598 15.1536 12.2924C15.1536 12.625 14.8838 12.8949 14.5511 12.8949H1.00068C0.668071 12.8949 0.398438 12.6253 0.398438 12.2927Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.4b685e597229c12e45b04399b0dd23bb.svg";
export { ForwardRef as ReactComponent };